import React from 'react';

import Icon from './Icon';

const Star = ({ className }) => (
  <Icon name="star" className={className} viewBox="0 0 27 25">
    <g stroke="none" strokeWidth="1" fillRule="evenodd">
      <g transform="translate(-399.000000, -433.000000)">
        <polygon points="412.5 453.096053 420.843 458 418.63575 448.751316 426 442.531579 416.29215 441.719737 412.5 433 408.70785 441.719737 399 442.531579 406.36425 448.751316 404.157 458" />
      </g>
    </g>
  </Icon>
);

// icon-star.svg
export default Star;
